import React from "react";
import Hero from "../Hero";

export default function LandingPage() {
  return (
    <div>
      <Hero />
    </div>
  );
}
